import React from 'react';
import './Auth.scss';

const AuthLayout = ({ children }: any) => {
  return (
    <div className="authContainer">
      <div className="container-auth">
        <div className="authpage">
          <div className="authLeft">
            <h2 className="home_title">Car Marketplace</h2>
            {/* <figure>
              <img src="/static/images/authLogo.png" alt="" />
            </figure> */}
            <p style={{ color: 'black', fontSize: '14px', textAlign: 'center' }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
              has been the industry's standard dummy text ever since the 1500s
            </p>
          </div>
          <div className="authRight">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
